import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";

import { RequestGreenCardSuccess } from "@/assets/icons";

import { StyledRequestGreenCardSuccess } from "./styled";

type GreenCardRequestSuccessInfoProps = {
    onSuccess: () => void;
    successResponse: string;
};

export enum SuccessResponseType {
    BROKER = "BROKER",
    DIRECT = "DIRECT",
}

const GreenCardRequestSuccessInfo: FC<GreenCardRequestSuccessInfoProps> = ({ onSuccess, successResponse }) => {
    const { t } = useTranslation();

    return (
        <StyledRequestGreenCardSuccess>
            <div className="requestInfo">
                <RequestGreenCardSuccess className="successImage" />

                <div className="successDialogText">
                    {successResponse === SuccessResponseType.BROKER
                        ? t("GreenCardRequest.requestSuccessBroker")
                        : t("GreenCardRequest.requestSuccessDirect")}
                </div>
            </div>

            <div className="btnWrapper">
                <Button fullWidth onClick={onSuccess}>
                    {t("Common.Ok")}
                </Button>
            </div>
        </StyledRequestGreenCardSuccess>
    );
};

export default GreenCardRequestSuccessInfo;
